import { useEffect, useState } from "react";
import axios from "axios";
import { MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const groupByDistrict = (notices) =>
  notices.reduce((acc, n) => {
    (acc[n.district] = acc[n.district] || []).push(n);
    return acc;
  }, {});

const Notices = () => {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/notices`)
      .then((res) => setNotices(res.data))
      .catch((err) => console.error("Failed to load notices", err));
  }, []);

  const districts = groupByDistrict(notices);

  return (
    <section id="live-notices" className="bg-night text-ink py-24 border-b border-line" data-testid="notices-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 pb-6 border-b border-line">
          <div>
            <p className="font-mono text-xs uppercase text-brand tracking-widest mb-2">Notice Feed</p>
            <h2 className="font-display text-[clamp(32px,4vw,56px)] uppercase tracking-wide">
              District-Wise Warehouse Points
            </h2>
          </div>
          <p className="text-sm font-mono text-mute">Jurisdiction: PAN-INDIA ONLINE</p>
        </div>

        {notices.length === 0 ? (
          <div className="border border-line p-8 bg-surface text-center" data-testid="notices-empty">
            <MapPin className="w-8 h-8 text-mute mx-auto mb-4" strokeWidth={1.5} />
            <p className="text-sm font-mono text-mute uppercase tracking-wider max-w-2xl mx-auto">
              No district-wise warehouse notifications released yet. New points are
              published here as they are notified — check back soon or register an enquiry below.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="notices-grid">
            {Object.entries(districts).map(([district, points], di) => (
              <div
                key={district}
                className="d1-card bg-surface border border-line hover:border-brand transition-colors"
                style={{ animationDelay: `${0.1 * (di + 1)}s` }}
                data-testid={`district-card-${district.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <div className="flex justify-between items-center px-6 py-4 border-b border-line">
                  <span className="font-mono text-xs uppercase tracking-widest text-brand font-bold">
                    {district}
                  </span>
                  <span className="font-mono text-[11px] text-mute">
                    {points.length} point{points.length === 1 ? "" : "s"}
                  </span>
                </div>
                <ul>
                  {points.map((p) => (
                    <li key={p.id} className="px-6 py-4 border-b border-line last:border-b-0" data-testid={`notice-${p.id}`}>
                      <div className="flex justify-between items-baseline gap-4 mb-1">
                        <h3 className="text-sm font-bold uppercase">{p.point}</h3>
                        {p.sqft && (
                          <span className="font-mono text-[11px] text-brand whitespace-nowrap">{p.sqft}</span>
                        )}
                      </div>
                      {p.message && <p className="text-xs text-mute leading-relaxed mb-2">{p.message}</p>}
                      {p.deposit_amount ? (
                        <p className="font-mono text-[11px] text-brand mb-2">
                          Security deposit: ₹{Number(p.deposit_amount).toLocaleString("en-IN")}
                        </p>
                      ) : null}
                      <p className="font-mono text-[10px] text-mute uppercase tracking-wider">
                        Released: {new Date(p.released_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Notices;
